import React from "react";
import styled from "styled-components";

import Modal, { ModalBody, ModalFooter, ModalHeader, Sheets } from "@ingka/modal";
import { colourStaticIkeaBrandYellow } from "@ingka/variables/colours-css";

const StyledHeader = styled(ModalHeader)`
	background-color: ${colourStaticIkeaBrandYellow};
`;

type Props = {
	visible: boolean;
	onClose: () => void;
	children?: React.ReactNode;
	title?: string;
};

const ModalComponent: React.FunctionComponent<Props> = ({ visible, onClose, children, title }) => {
	return (
		<Modal visible={visible} handleCloseBtn={onClose}>
			<Sheets
				aria-labelledby="modalTitleId"
				header={<StyledHeader title={title} titleId="modalTitleId" />}
				footer={<ModalFooter children={undefined} />}
			>
				<ModalBody>{children}</ModalBody>
			</Sheets>
		</Modal>
	);
};

export default ModalComponent;
